/**
 * Load a stylesheet dynamically
 *
 * @param {string} href - The URL of the stylesheet to load
 * @returns {Promise<void>} - A promise that resolves when the stylesheet is loaded
 */ const loadStyleSheet = (href)=>{
    return new Promise((resolve, reject)=>{
        try {
            const script = document.createElement('link');
            script.href = href;
            script.rel = 'stylesheet';
            script.onload = ()=>{
                resolve();
            };
            document.head.appendChild(script);
        } catch (error) {
            reject(error);
        }
    });
};
export default loadStyleSheet;
